import React from 'react';
import ProductCarousel from '../products/ProductCarousel';
import ProductGridSkeleton from '../products/ProductGridSkeleton';

const WeeklyFeatured = ({ products, loading }) => {
  if (loading) {
    return (
      <div className="py-5 sm:py-7">
        <h2 className="text-2xl font-bold mb-6 text-center">Haftanın Ürünleri</h2>
        <ProductGridSkeleton columns={4} count={4} />
      </div>
    );
  }

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <ProductCarousel
      title="Haftanın Ürünleri"
      products={products}
      compactSection
    />
  );
};

export default WeeklyFeatured;
